import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getLocation() {
  return httpService.get(ApiUrl.LOCATION);
}

const obj = { getLocation };

export default obj;
